import { render, staticRenderFns } from "./EcologicalGroup.vue?vue&type=template&id=fad7087c&scoped=true&"
import script from "./EcologicalGroup.vue?vue&type=script&lang=js&"
export * from "./EcologicalGroup.vue?vue&type=script&lang=js&"
import style0 from "./EcologicalGroup.vue?vue&type=style&index=0&id=fad7087c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad7087c",
  null
  
)

export default component.exports